import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, DataTable } from "../components/Table";
import { CheckCircle, Warning } from "@phosphor-icons/react";

export default function GovPush() {
  const [states, setStates] = useState([]);
  useEffect(() => { api.get("/gov-push").then((r) => setStates(r.data.states)); }, []);

  const columns = [
    { key: "state", header: "State", render: (r) => <span className="font-semibold">{r.state}</span> },
    { key: "devices", header: "Devices", render: (r) => r.devices.toLocaleString() },
    { key: "success_pct", header: "Success", render: (r) => (
      <span className="flex items-center gap-2 font-mono" style={{ color: r.success_pct > 99 ? "#34C759" : "#FF9500" }}>
        {r.success_pct}% {r.success_pct > 99 ? <CheckCircle size={14} weight="fill" /> : <Warning size={14} weight="fill" />}
      </span>
    )},
    { key: "failed_pct", header: "Failed", render: (r) => <span className="font-mono text-muted-foreground">{r.failed_pct}%</span> },
    { key: "bar", header: "", render: (r) => (
      <div className="w-40 h-2 bg-secondary rounded-sm overflow-hidden">
        <div className="h-full" style={{ width: `${r.success_pct}%`, background: r.success_pct > 99 ? "#34C759" : "#FF9500" }} />
      </div>
    )},
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="Government Data Push" subtitle="State VLTD / VAHAN / ERSS transmission monitor" />
      <DataTable testid="gov-push-table" columns={columns} rows={states} />
    </div>
  );
}
